$(() => {
    // モーダルOpen
    $('.js-modal-paid-lot-item-open').on('click', e => {
        e.preventDefault();
        const id = e.currentTarget.dataset.for;
        $(`.js-modal-paid-lot-item[data-id="${id}"]`).show();
        $('body').addClass('show-modal');
    });
    // モーダルClose
    $('.js-modal-paid-lot-item-close').on('click', e => {
        e.preventDefault();
        $('.js-modal-paid-lot-item').hide();
        $('body').removeClass('show-modal');
    });
    $('.js-modal-paid-lot-item').toArray().forEach((modal, index, modals) => {
        // 前後のモーダルへ移動
        $(modal).find('.js-modal-paid-lot-item-move').each((_, button) => {
            const direction = parseInt(button.dataset.direction);
            // 前後のモーダル
            const to = modals[index + direction];
            // なければボタン削除
            if (!to) {
                $(button).hide();
                return;
            }
            $(button).on('click', e => {
                e.preventDefault();
                $(modal).hide();
                $(to).show();
            });
        });
        // 画像の切り替え
        const $image = $(modal).find('.js-paid-lot-item-modal-image');
        $(modal).find('.js-paid-lot-item-modal-images').on('click', e => {
            $image.attr('style', $(e.currentTarget).attr('style'));
        });
    });
});
